import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-bg mt-16 sm:mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Columna 1 - Branding */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/5bc5f722-4c51-4a16-b952-a25cd81fdf88.png"
                alt="PLADUREX"
                className="h-12 sm:h-14 w-auto"
              />
              <span className="text-text-primary text-xl sm:text-2xl font-bold">PLADUREX</span>
            </Link>
            <p className="text-text-muted text-sm sm:text-[15px] leading-relaxed mb-4">
              Instaladores profesionales de pladur en Badalona y Barcelona
            </p>
            <p className="text-text-muted text-sm leading-relaxed">
              <Link to="/empresa" className="text-orange-primary hover:underline">Conoce nuestra empresa</Link> y descubre por qué somos especialistas en construcción en seco.
            </p>
          </div>

          {/* Columna 2 - Navegación */}
          <div>
            <h2 className="text-text-primary text-base sm:text-lg font-bold mb-4 sm:mb-6">Navegación</h2>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link
                  to="/empresa"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Sobre nosotros
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Nuestros servicios
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Preguntas frecuentes
                </Link>
              </li>
              <li>
                <Link
                  to="/contacto"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Solicitar presupuesto
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 3 - Servicios */}
          <div>
            <h2 className="text-text-primary text-base sm:text-lg font-bold mb-4 sm:mb-6">Servicios</h2>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/servicios#tabiques"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Tabiques de pladur
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios#trasdosados"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Trasdosados
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios#techos"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Falsos techos
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios#aislamiento-acustico"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Aislamiento acústico
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios#aislamiento-termico"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Aislamiento térmico
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios#antihumedad"
                  className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-sm sm:text-[15px]"
                >
                  Pladur antihumedad
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 4 - Contacto */}
          <div>
            <h2 className="text-text-primary text-base sm:text-lg font-bold mb-4 sm:mb-6">Contacto</h2>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+34629501941"
                  className="flex items-center space-x-3 text-text-primary hover:text-orange-primary transition-colors duration-300 group"
                >
                  <i className="ri-phone-line text-orange-primary text-xl w-6 h-6 flex items-center justify-center flex-shrink-0"></i>
                  <span className="text-sm sm:text-[15px] font-medium break-all">629 501 941</span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/34629501941"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-text-primary hover:text-orange-primary transition-colors duration-300 group"
                >
                  <i className="ri-whatsapp-line text-[#25D366] text-xl w-6 h-6 flex items-center justify-center flex-shrink-0"></i>
                  <span className="text-sm sm:text-[15px] font-medium">WhatsApp</span>
                </a>
              </li>
              <li className="flex items-start space-x-3 text-text-muted">
                <i className="ri-map-pin-line text-orange-primary text-xl w-6 h-6 flex items-center justify-center mt-0.5 flex-shrink-0"></i>
                <span className="text-sm sm:text-[15px]">Badalona y Barcelona</span>
              </li>
            </ul>
            <div className="mt-6">
              <Link
                to="/contacto"
                className="inline-flex items-center space-x-2 text-orange-primary hover:underline text-sm font-medium"
              >
                <span>Formulario de contacto</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>

        {/* Barra inferior */}
        <div className="mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-dark-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-text-muted text-xs sm:text-sm text-center md:text-left break-words">
              © {currentYear} PLADUREX - Instalación de pladur en Badalona | Todos los derechos reservados
            </p>
          </div>
          
          {/* Enlaces legales */}
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mt-4 sm:mt-6">
            <Link
              to="/politica-cookies"
              className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-xs sm:text-sm"
            >
              Política de Cookies
            </Link>
            <span className="text-text-muted">|</span>
            <Link
              to="/aviso-legal"
              className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-xs sm:text-sm"
            >
              Aviso Legal
            </Link>
            <span className="text-text-muted">|</span>
            <Link
              to="/politica-privacidad"
              className="text-text-muted hover:text-orange-primary transition-colors duration-300 text-xs sm:text-sm"
            >
              Política de Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
